(function() {
  var Router,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  exports.ToolsRouter = (function(superClass) {
    extend(ToolsRouter, superClass);

    function ToolsRouter() {
      return ToolsRouter.__super__.constructor.apply(this, arguments);
    }

    ToolsRouter.prototype.prefix = 'Tools';

    ToolsRouter.prototype.module_name = 'ToolsRouter';

    ToolsRouter.prototype.register = function() {
      this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
      this.service('admin::Angular/Tools/ManageUsers/ManageUsersService', ['$http', '$rootScope']);
      this.controller('admin::Angular/Tools/ManageUsers/ManageUsersController', ['$scope', '$transitions', '$uibModal', 'Tools.Services.ManageUsersService', '$window', '$http']);
      this.controller('admin::Angular/Tools/ManageUsers/ViewAccountInfoController', ['$scope', '$transitions', '$uibModal', '$uibModalInstance', 'Tools.Services.ManageUsersService', 'account']);
      this.controller('admin::Angular/Tools/ManageUsers/EditCompaniesController', ['$scope', '$transitions', '$uibModalInstance', 'Tools.Services.ManageUsersService', 'associations']);
      this.controller('admin::Angular/Tools/ManageUsers/EditContactInfoController', ['$scope', '$transitions', '$uibModalInstance', 'Tools.Services.ManageUsersService', 'contact']);
      this.controller('admin::Angular/Tools/ManageUsers/EditRolesController', ['$scope', '$transitions', '$uibModalInstance', 'Tools.Services.ManageUsersService', 'roles']);
      this.service('admin::Angular/Tools/SmsLogService', ['$http', '$rootScope']);
      this.controller('admin::Angular/Tools/SmsLogController', ['$scope', '$transitions', 'Tools.Services.SmsLogService', '$window', '$http']);
      this.service('admin::Angular/Tools/SmsResubscribeService', ['$http', '$rootScope']);
      this.controller('admin::Angular/Tools/SmsResubscribeController', ['$scope', '$transitions', 'Tools.Services.SmsResubscribeService', '$window', '$http']);
      this.service('admin::Angular/Tools/GenerateKeyFieldsService', ['$http', '$rootScope']);
      this.controller('admin::Angular/Tools/GenerateKeyFieldsController', ['$scope', '$transitions', 'Tools.Services.GenerateKeyFieldsService', '$http']);
      this.service('admin::Angular/Tools/CompaniesService', ['$http', '$rootScope']);
      this.controller('admin::Angular/Tools/CompaniesController', ['$scope', '$transitions', '$uibModal', 'Tools.Services.CompaniesService', '$http']);
      this.controller('admin::Angular/Tools/NewCompanyController', ['$scope', '$transitions', '$uibModalInstance', 'Tools.Services.CompaniesService']);
      this.controller('admin::Angular/Tools/EditCompanyPagesController', ['$scope', '$transitions', '$uibModalInstance', 'Tools.Services.CompaniesService', 'company', 'pages', 'reports']);
      this.controller('admin::Angular/Tools/EditCompanyLineupsController', ['$scope', '$transitions', '$uibModal', '$uibModalInstance', 'Tools.Services.CompaniesService', 'company', 'lineups', 'crops', 'seedCompanies']);
      this.controller('admin::Angular/Tools/SeedCompanyDialogController', ['$scope', '$transitions', '$uibModalInstance', 'Tools.Services.CompaniesService', '$q', '$http']);
      this.service('admin::Angular/Tools/BushelsService', ['$http', '$rootScope']);
      this.controller('admin::Angular/Tools/BushelsController', ['$scope', '$transitions', '$uibModal', 'Tools.Services.BushelsService', '$q', '$http']);
      this.service('admin::Angular/Tools/ChemicalsService', ['$http', '$rootScope']);
      this.controller('admin::Angular/Tools/ChemicalsController', ['$scope', '$transitions', '$uibModal', 'Tools.Services.ChemicalsService', '$q', 'Core.Services.Loading', '$http']);
      this.controller('admin::Angular/Tools/ChemicalsChildrenController', ['$scope', '$transitions', '$uibModalInstance', 'Tools.Services.ChemicalsService', 'chemical', 'chemicals']);
      this.service('admin::Angular/Tools/Uploads/UploadsService', ['$http', '$rootScope']);
      this.controller('admin::Angular/Tools/Uploads/UploadsController', ['$scope', '$transitions', 'Tools.Services.UploadsService', '$http']);
      this.module.filter('numFilter', function() {
        return function(collection, text) {
          var i, j, len, list, num;
          if (text === '') {
            return collection;
          }
          list = [];
          for (i = j = 0, len = collection.length; j < len; i = ++j) {
            num = collection[i];
            num = num.toString();
            if (num.indexOf(text) !== -1) {
              list.push(num);
            }
          }
          return list;
        };
      });
      this.service('admin::Angular/Tools/SppAnalysisService', ['$http', '$rootScope']);
      this.controller('admin::Angular/Tools/SppAnalysisController', ['$scope', '$transitions', 'Tools.Services.SppAnalysisService', '$window', '$http']);
      this.service('admin::Angular/Tools/SlackFiles/SlackFilesService', ['$http', '$rootScope']);
      this.controller('admin::Angular/Tools/SlackFiles/SlackFilesController', ['$scope', '$transitions', 'Tools.Services.SlackFilesService', '$q', '$http']);
      this.service('admin::Angular/Tools/ValidationExample/ValidationExampleService', ['$http', '$rootScope']);
      return this.controller('admin::Angular/Tools/ValidationExample/ValidationExampleController', ['$scope', '$transitions', 'Tools.Services.ValidationExampleService', '$q', '$http']);
    };

    ToolsRouter.prototype.registerRoutes = function($stateProvider) {
      return $stateProvider.state('admin.tools', {
        url: '/tools',
        templateUrl: 'backend/admin/new-tools/sidebar',
        controller: [
          '$scope', '$state', function($scope, $state) {
            return $scope.show_fullpage = true;
          }
        ]
      }).state('admin.tools.manage_users', {
        url: '/manage-users',
        views: {
          fullpage: {
            templateUrl: 'backend/admin/new-tools/manage-users',
            controller: 'Tools.Controllers.ManageUsersController'
          }
        }
      }).state('admin.tools.sms_log', {
        url: '/sms-log',
        views: {
          fullpage: {
            templateUrl: 'backend/admin/new-tools/sms-log/dialog',
            controller: 'Tools.Controllers.SmsLogController'
          }
        }
      }).state('admin.tools.sms_resubscribe', {
        url: '/sms-resubscribe',
        views: {
          fullpage: {
            templateUrl: 'backend/admin/new-tools/sms-resubscribe/dialog',
            controller: 'Tools.Controllers.SmsResubscribeController'
          }
        }
      }).state('admin.tools.generate_key_fields', {
        url: '/generate-key-fields',
        views: {
          fullpage: {
            templateUrl: 'backend/admin/new-tools/generate-key-fields/dialog',
            controller: 'Tools.Controllers.GenerateKeyFieldsController'
          }
        }
      }).state('admin.tools.companies', {
        url: '/companies',
        views: {
          fullpage: {
            templateUrl: 'backend/admin/new-tools/companies/dialog',
            controller: 'Tools.Controllers.CompaniesController'
          }
        }
      }).state('admin.tools.bushels', {
        url: '/bushels',
        views: {
          fullpage: {
            templateUrl: 'backend/admin/new-tools/bushels/dialog',
            controller: 'Tools.Controllers.BushelsController'
          }
        }
      }).state('admin.tools.chemicals', {
        url: '/chemicals',
        views: {
          fullpage: {
            templateUrl: 'backend/admin/new-tools/chemicals/dialog',
            controller: 'Tools.Controllers.ChemicalsController'
          }
        }
      }).state('admin.tools.spp_analysis', {
        url: '/spp-analysis',
        views: {
          fullpage: {
            templateUrl: 'backend/admin/spp-analysis/dialog',
            controller: 'Tools.Controllers.SppAnalysisController'
          }
        }
      }).state('admin.tools.slack_files', {
        url: '/slack-files',
        views: {
          fullpage: {
            templateUrl: 'backend/admin/slack-files/dialog',
            controller: 'Tools.Controllers.SlackFilesController'
          }
        }
      }).state('admin.tools.validation_example', {
        url: '/validation-example',
        views: {
          fullpage: {
            templateUrl: 'backend/admin/validation-example/view',
            controller: 'Tools.Controllers.ValidationExampleController'
          }
        }
      }).state('admin.tools.uploads', {
        url: '/uploads',
        views: {
          fullpage: {
            templateUrl: 'backend/admin/new-tools/uploads/dialog',
            controller: 'Tools.Controllers.UploadsController'
          }
        }
      });
    };

    return ToolsRouter;

  })(Router);

}).call(this);
